import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import PersonRoundedIcon      from "@mui/icons-material/PersonRounded";
import DirectionsCarRoundedIcon from "@mui/icons-material/DirectionsCarRounded";
import AllDriversTab from "./AllDriversTab.js";
import OnDutyTab     from "./OnDutyTab.js";

const T = {
    teal: "#007C84", tealDk: "#016268", tealLt: "#E0F4F5",
    bg: "#F7FAFC", border: "#E2E8F0", muted: "#64748B",
};

const TabBtn = ({ label, icon, active, onClick }) => (
    <Box onClick={onClick} sx={{
        display: "flex", alignItems: "center", gap: 1,
        px: 2.5, py: 1.2, borderRadius: "10px", cursor: "pointer",
        bgcolor: active ? T.teal : "transparent",
        color:   active ? "#fff" : T.muted,
        fontWeight: active ? 700 : 500, fontSize: 13,
        transition: "all 0.15s", flexShrink: 0,
        "&:hover": { bgcolor: active ? T.teal : T.tealLt, color: active ? "#fff" : T.teal },
        fontFamily: "'Plus Jakarta Sans', sans-serif",
    }}>
        {React.cloneElement(icon, { sx: { fontSize: 16 } })}
        {label}
    </Box>
);

export default function Drivers() {
    const [tab, setTab] = useState("all");

    return (
        <Box sx={{ bgcolor: T.bg, minHeight: "100vh", pb: 4 }}>
            {/* Hero header */}
            <Box sx={{
                background: `linear-gradient(135deg, ${T.teal} 0%, ${T.tealDk} 100%)`,
                borderRadius: "20px", p: 3, mb: 3,
                boxShadow: "0 4px 20px rgba(0,124,132,0.2)",
            }}>
                <Typography sx={{ fontSize: 22, fontWeight: 800, color: "#fff", fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                    Drivers
                </Typography>
                <Typography sx={{ fontSize: 13, color: "rgba(255,255,255,0.75)", mt: 0.5 }}>
                    Manage and monitor all registered drivers
                </Typography>
            </Box>

            {/* Tab toggle */}
            <Box sx={{ display: "flex", gap: 0.5, bgcolor: "white", border: `1px solid ${T.border}`, borderRadius: "14px", p: 0.75, mb: 3, width: "fit-content" }}>
                <TabBtn label="All Drivers" icon={<PersonRoundedIcon />}          active={tab === "all"}     onClick={() => setTab("all")} />
                <TabBtn label="On Duty"     icon={<DirectionsCarRoundedIcon />}   active={tab === "onduty"}  onClick={() => setTab("onduty")} />
            </Box>

            {tab === "all"    && <AllDriversTab />}
            {tab === "onduty" && <OnDutyTab />}
        </Box>
    );
}
